import QRCodeStyling from 'qr-code-styling'
import { useEffect, useRef } from 'react'

interface QrCodeProps {
  value: string;
  size?: number;
  className?: string;
}

export default function QrCode ({ value, size = 256, className }: QrCodeProps) {
  const ref = useRef<HTMLDivElement>(null)
  const qrCodeRef = useRef<QRCodeStyling | null>(null)

  useEffect(() => {
    if (!qrCodeRef.current) {
      qrCodeRef.current = new QRCodeStyling({
        width: size,
        height: size,
        data: value,
        qrOptions: {
          errorCorrectionLevel: 'Q'
        },
        dotsOptions: {
          color: '#000000',
          type: 'square'
        },
        cornersSquareOptions: {
          color: '#000000',
          type: 'dot'
        },
        cornersDotOptions: {
          color: '#000000',
          type: 'dot'
        },
        imageOptions: {
          crossOrigin: 'anonymous',
          margin: -4,
          imageSize: 0.2
        },
      })
    }
  }, [ size, value ])

  useEffect(() => {
    const currentRef = ref.current

    if (qrCodeRef.current && currentRef) {
      qrCodeRef.current.append(currentRef)
    }

    return () => {
      if (currentRef) {
        currentRef.innerHTML = ''
      }
    }
  }, [])

  useEffect(() => {
    if (qrCodeRef.current && value) {
      qrCodeRef.current.update({ data: value })
    }
  }, [ value ])

  useEffect(() => {
    if (qrCodeRef.current) {
      qrCodeRef.current.update({
        width: size,
        height: size
      })
    }
  }, [ size ])

  return <div ref={ref} className={className} />
}